import { useApi } from '../composables/useApi'
import { URLS } from '../constants/urls'

export default function calendarioService() {
	const api = useApi()

	async function getEventos(params) {
		return await api.query(`${URLS.calendario}`, params)
	}

	async function getEventosUsuario(params) {
		return await api.query(`${URLS.clientes_calendar_user_events_api}`, params)
	}

	async function getUsuariosCalendarios() {
		return await api.query(`${URLS.clientes_calendar_user_api}`)
	}

	async function authMicrosoft(params) {
		return await api.query(`${URLS.calendario_auth}`, params)
	}

	async function createEvento(data) {
		return await api.mutation(`${URLS.calendario}`, 'post', data)
	}

	async function updateEvento(data) {
		return await api.mutation(`${URLS.calendario}`, 'patch', data)
	}

	async function deleteEvento(id, data = null) {
		return await api.mutation(`${URLS.calendario}?id=${id}`, 'delete', data)
	}

	return {
		...api,
		getEventos,
		getEventosUsuario,
		authMicrosoft,
		createEvento,
		updateEvento,
		deleteEvento,
		getUsuariosCalendarios,
	}
}
